
import { computed, defineComponent } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'session-form-field-repeat-password',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        password: {
            type: String,
            required: true
        }
    },
    setup (props) {
        const {
            validations: {
                passwordRule,
                repeatPasswordRule: createRepeatPasswordRule,
                requiredRule
            }
        } = useFormModule()

        const repeatPasswordRule = createRepeatPasswordRule(computed(() => props.password))
        return {
            requiredRule,
            passwordRule,
            repeatPasswordRule
        }
    }
})
